// services/cashStart.ts
//
// Cash start — "show zero, keep history" (client, 2026-10-13).
//
// Cash on hand is never stored: every screen works it out as the cash from
// delivered cash orders minus the cash turn-ins. The client asked to zero what
// Wolf shows for drivers and for stores and to start fresh, with every record
// left as it is. So nothing is deleted and nothing is edited: a delivery or a
// turn-in from BEFORE the moment below simply no longer counts toward a
// balance. Reports, order history and the turn-in records read the rows
// themselves and are unchanged.
//
// To start fresh again later, move the moment forward. To bring the old numbers
// back, set it to 0. No react / expo / project imports on purpose: this file is
// the same, byte for byte, in DispatchSystem and in wolfdriver-mobile, so the
// office and the phone agree on the moment.

/** 2026-10-13 08:00 in Ottawa (12:00 UTC) — before that day's shift. */
export const CASH_START_MS = Date.UTC(2026, 9, 13, 12, 0, 0);

/** Does something that happened at `at` count toward a cash balance?
 *  A row with no time on it is an old row: it does not count. */
export function sinceCashStart(at: number | null | undefined, startMs: number = CASH_START_MS): boolean {
  return typeof at === 'number' && at >= startMs;
}
